import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';

@Component({ className: 'js-interactive-svg' })
export class InteractiveSvgComponent {
	private file?: HTMLElement | undefined | null;
	private triggers?: HTMLElement[] | undefined | null;

	constructor(private element: HTMLElement) {
		this.file = element.querySelector('.js-interactive-svg-file');
		this.triggers = Array.from(
			element.querySelectorAll('.js-interactive-svg-trigger')
		) as HTMLElement[];
		if (this.triggers && this.triggers.length > 0) {
			this.triggers.forEach((trigger) => {
				const type = trigger.getAttribute("data-type");
				const targets = Array.from(
					this.file?.querySelectorAll(
						`[id^='${trigger.getAttribute('data-target')}']`
					) || []
				) as HTMLElement[];
				if (targets && targets.length > 0) {
					targets.forEach((target) => {
						addClass(target, 'c-interactive-svg-target');
						if (type) {
							addClass(target, `type--${type}`);
						}
						target.addEventListener('click', () => {
							addClass(target, 'is-active');
							trigger.click();
						});
						target.addEventListener('mouseenter', () => {
							addClass(target, 'is-active');
						});
						target.addEventListener('mouseleave', () => {
							removeClass(target, 'is-active');
						});
					});
				}
			});
		}
	}
}
